export type SpeakerWhaleMissionStep = {
  seq: number;
  kind: string;
  summary?: string;
  peerName?: string;
  agentName?: string;
};

function stepActionLabel(step: SpeakerWhaleMissionStep): string {
  const summary = step.summary?.trim();
  if (summary) return summary;
  switch (step.kind) {
    case "plan":
      return "pianifica la missione";
    case "delegate":
    case "delegate_start":
      return "delega al team";
    case "tool":
    case "tool_start":
      return "usa uno strumento";
    case "script":
    case "script_start":
      return "esegue uno script";
    case "model":
      return "genera la risposta";
    case "model_start":
      return "sta generando la risposta";
    case "web_ingest":
    case "web_ingest_start":
      return "ricerca sul web";
    default:
      return step.kind.replace(/_/g, " ");
  }
}

/** Single-line live status for the Whale popover while the mission runs. */
export function formatSpeakerWhaleLiveStep(
  steps: SpeakerWhaleMissionStep[],
  fallbackAgentName: string,
): string {
  if (!steps.length) {
    return `${fallbackAgentName} sta elaborando…`;
  }
  const step = steps[steps.length - 1]!;
  const actor = step.peerName?.trim() || step.agentName?.trim() || fallbackAgentName;
  const action = stepActionLabel(step);
  return `Passo ${steps.length} · ${actor}: ${action}`;
}
